import WarplyOverview from '@/modules/integrations/types/warply/WarplyOverview'
import WarplySettings from '@/modules/integrations/types/warply/WarplySettings'
import WarplyCouponsets from '@/modules/integrations/types/warply/WarplyCouponsets'
import WarplySyncDialog from '@/modules/integrations/types/warply/WarplySyncDialog'

export default Object.freeze({
  type: 'warply',
  title: 'Integrations_Warply',
  category: 'Integrations_Warply_Category',
  description: 'Integrations_Warply_Description',
  image: require('@/img/integrations/warply.png'),
  requiresAdmin: false,
  components: {
    overview: WarplyOverview,
    settings: WarplySettings,
    couponsets: WarplyCouponsets
  },
  actions: [
    {
      icon: 'el-icon-refresh',
      label: 'Integrations_Warply_Action_Sync',
      dialog: WarplySyncDialog
    }
  ],
  urls: {
    guide: 'https://docs.xtremepush.com/docs/warply'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/warply/index.js